// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3_uhE","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1184I"};